import React, { useState, useEffect } from 'react'
import pickleballPlayPass from "../../../Asset/Membership/MembershipSchedule/pickleball-play-pass.svg"
import footballPlayPass from "../../../Asset/Membership/MembershipSchedule/football-play-pass.svg"
import pickleballCocahing from "../../../Asset/Membership/MembershipSchedule/pickleball-coaching.svg"
import fitnessBootcamp from "../../../Asset/Membership/MembershipSchedule/fitness-bootcamp.svg"
import membershipTool from './MembershipTool.json'
import './MembershipScheduleSection.css'
import MembershipScheduleSectionWeb from './MembershipScheduleSectionWeb'
import MembershipScheduleSectionMobile from './MembershipScheduleSectionMobile'

const OFFERING_IMAGES = {
  'Pickle PlayPass': pickleballPlayPass,
  'Football PlayPass': footballPlayPass,
  //   'Padel PlayPass': padelPlayPass,
  'Pickle Coaching': pickleballCocahing,
  'Football Coaching': footballPlayPass,
  'Padel Coaching': pickleballCocahing,
  'NG Bootcamp': fitnessBootcamp,
  'Fitness Bootcamp': fitnessBootcamp,
}

const CREDIT_MAP = {
  'Pickle PlayPass': 15,
  'Football PlayPass': 5,
  'Padel PlayPass': 12,
  'Pickle Coaching': 10,
  'Football Coaching': 8,
  'Padel Coaching': 10,
  'NG Bootcamp': 15,
  'NG Social': 5,
  'NG Event': 8,
  'Coaching': 10,
  'Fitness Bootcamp': 15,
}

const MembershipScheduleSection = () => {
  const [selectedSports, setSelectedSports] = useState({
    football: false,
    padel: false,
    pickleball: false,
  })
  const [selectedTier, setSelectedTier] = useState(null)
  const [offerings, setOfferings] = useState([])
  const [offeringsViewed, setOfferingsViewed] = useState(false)

  const getComboKey = (sports) => {
    const sportOrder = ['pickleball', 'football', 'padel']
    const active = sportOrder.filter(s => sports[s])
    return active.length === 0 ? null : active.join('+')
  }

  const handleSportToggle = (sport) => {
    setSelectedSports(prev => ({
      ...prev,
      [sport]: !prev[sport]
    }))
  }

  const handleTierSelect = (tier) => {
    setSelectedTier(tier)
  }

  const handleSeeOfferings = () => {
    const comboKey = getComboKey(selectedSports)
    if (!comboKey || !selectedTier) {
      setOfferings([])
      return
    }
    const tierData = membershipTool[selectedTier]
    const result = tierData[comboKey] || []
    setOfferings(result)
    setOfferingsViewed(true)
  }

  const isFormValid = Object.values(selectedSports).some(v => v) && selectedTier

  // Auto-fetch offerings when selections change after first view
  useEffect(() => {
    if (offeringsViewed) {
      const hasSelectedSport = Object.values(selectedSports).some(v => v)
      
      if (!hasSelectedSport) {
        setOfferings([])
      } else if (selectedTier) {
        const comboKey = getComboKey(selectedSports)
        const tierData = membershipTool[selectedTier]
        const result = tierData[comboKey] || []
        setOfferings(result)
      } else {
        setOfferings([])
      }
    }
  }, [selectedSports, selectedTier, offeringsViewed])

  return (
    <div id='membership-schedule-section' className='my-24 w-[94%] mx-auto'>
      <div id="membership-schedule-section-container">
        {/* Top heading - hidden on mobile */}
        <div className='hidden md:block font-ClashGrotesk text-[2.3rem] md:text-[3.5rem] leading-[2.85rem] md:leading-[3.85rem] text-[var(--dark-blue)] font-[520] mb-8'>
          Let's build your sample Net Gala schedule!
        </div>

        {/* Web view */}
        <div className='hidden md:block'>
          <MembershipScheduleSectionWeb
            selectedSports={selectedSports}
            selectedTier={selectedTier}
            offerings={offerings}
            handleSportToggle={handleSportToggle}
            handleTierSelect={handleTierSelect}
            handleSeeOfferings={handleSeeOfferings}
            isFormValid={isFormValid}
            OFFERING_IMAGES={OFFERING_IMAGES}
            CREDIT_MAP={CREDIT_MAP}
          />
        </div>

        {/* Mobile view */}
        <div className='md:hidden'>
          <MembershipScheduleSectionMobile
            selectedSports={selectedSports}
            selectedTier={selectedTier}
            offerings={offerings}
            handleSportToggle={handleSportToggle}
            handleTierSelect={handleTierSelect}
            handleSeeOfferings={handleSeeOfferings}
            isFormValid={isFormValid}
            OFFERING_IMAGES={OFFERING_IMAGES}
            CREDIT_MAP={CREDIT_MAP}
          />
        </div>

      </div>
    </div>
  )
}

export default MembershipScheduleSection
